import * as angular from "angular";
import { Group } from "../../models/group.model";
import { Team } from "../../models/team.model";
import { TeamDataProvider } from "../../data-provider/team.dp";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { GroupDataProvider } from "../../data-provider/group.dp";
import { Assignment } from "../../models/assignment.model";

let SegmentGroupComponent = {
    selector: "vcSegmentGroup",
    templateUrl:
        "/angular/components/group/segment-group-dialog.component.html",
    bindings: {
        gid: "=",
        created: "=",
    },
    controller: class SegmentGroupController {
        // * bindings for typescript compiler *
        public gid: string;
        public created: boolean;
        // ************************************

        public searchText = "";
        public loading = true;
        public assignment: Assignment;
        public group: Group;
        public usersCount: number;

        private $scope: object;
        private dialog: DialogUtils;
        private toast: ToastUtils;
        private modelsUtils: any;

        public teamDataProvider: TeamDataProvider;
        public groupDataProvider: GroupDataProvider;
        public dataProvider: GroupDataProvider;

        constructor(
            $scope: any,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils,
            TeamDataProvider: TeamDataProvider,
            GroupDataProvider: GroupDataProvider,
            ModelsUtils: any
        ) {
            this.$scope = $scope;
            this.dialog = DialogUtils;
            this.toast = ToastUtils;
            this.modelsUtils = ModelsUtils;

            this.teamDataProvider = TeamDataProvider;
            this.groupDataProvider = GroupDataProvider;
            this.dataProvider = GroupDataProvider;
        }

        $onInit() {
            this.groupDataProvider.getGroup(this.gid).then((group) => {
                this.group = group;
                this.loading = false;
            });
        }

        assign(ev: object): void {
            this.dialog
                .show({
                    component: "vc-group-assignment",
                    scope: this.$scope,
                    size: "large",
                    locals: {
                        listName: this.group.gname,
                        assignment: this.modelsUtils.assignment({
                            assignmentname: "Split " + this.group.gname,
                        }),
                    },
                })
                .then((assignment: Assignment) => {
                    this.loading = false;
                    let usersCount = assignment.users.length;
                    angular.forEach(assignment.teams, (team: Team) => {
                        usersCount += team["team_users_count"];
                    });
                    this.usersCount = usersCount;
                    this.assignment = assignment;
                    this.group.assignments = [assignment];
                });
        }

        groupBigEnough(): boolean {
            let houses = parseInt(this.group.num_houses);
            let houseOccupants = parseInt(this.group.num_houseoccupants);

            let count: number =
                houses > houseOccupants ? houses : houseOccupants;

            return !this.assignment || count >= this.usersCount;
        }

        confirm(): void {
            this.loading = true;
            this.dataProvider.segment(this.group).then(
                () => {
                    this.dialog.hide();
                    this.loading = false;
                },
                () => {
                    this.dialog.hide();
                    this.toast.error();
                }
            );
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("group")
    .component(SegmentGroupComponent.selector, SegmentGroupComponent);
